var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1649 9.40527H5.83157C5.6737 9.40527 5.5223 9.46799 5.41067 9.57961C5.29904 9.69124 5.23633 9.84264 5.23633 10.0005C5.23633 10.1584 5.29904 10.3098 5.41067 10.4214C5.5223 10.533 5.6737 10.5957 5.83157 10.5957H14.1649C14.3228 10.5957 14.4742 10.533 14.5858 10.4214C14.6974 10.3098 14.7601 10.1584 14.7601 10.0005C14.7601 9.84264 14.6974 9.69124 14.5858 9.57961C14.4742 9.46799 14.3228 9.40527 14.1649 9.40527Z",
    fill: "#875B52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#875B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.818036f333e165b47cadec80f2b1d694.svg";
export { ForwardRef as ReactComponent };